/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface ExportTransactionsRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    accountId?: string | null;
    typeIds?: Array<number> | null;
    datePeriod?: DateTimePeriod;
}

